import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedIntegrationState {
  integrationId: string | null;
}

const initialState: SelectedIntegrationState = {
  integrationId: null,
};

const selectedIntegrationSlice = createSlice({
  name: 'selectedIntegration',
  initialState,
  reducers: {
    setSelectedIntegration(state, action: PayloadAction<string>) {
      state.integrationId = action.payload;
    },
    clearSelectedIntegration(state) {
      state.integrationId = null;
    },
  },
});

export const { setSelectedIntegration, clearSelectedIntegration } = selectedIntegrationSlice.actions;
export default selectedIntegrationSlice.reducer;
